import Container from "@mui/material/Container";

import ClientContainer from "../client";
import UserContainer from "../user";
import SolutionContainer from "../solution";
import BiodiversityContainer from "../biodiversity";
import { ReportingContainer } from "../reporting";
import ProspectContainer from "../prospect";
import { Route, Routes, useLocation } from "react-router";
import paths from "../../routes";

function Content() {
  const location = useLocation();
  const isProspectsPage = location.pathname.startsWith(
    paths.prospects.base.pattern,
  );

  return (
    <>
      <Container
        data-testid="content"
        maxWidth={false}
        sx={{
          flex: isProspectsPage ? "none" : 1,
          minHeight: isProspectsPage ? "auto" : 0,
          marginY: isProspectsPage ? 0 : "3rem",
          overflow: isProspectsPage ? "visible" : "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Routes>
          <Route
            path={paths.clients.base.pattern + "/*"}
            element={<ClientContainer />}
          />
          <Route
            path={paths.users.base.pattern + "/*"}
            element={<UserContainer />}
          />
          <Route
            path={paths.solutions.base.pattern + "/*"}
            element={<SolutionContainer />}
          />
          <Route
            path={paths.biodiversity.base.pattern + "/*"}
            element={<BiodiversityContainer />}
          />
          <Route
            path={paths.reporting.base.pattern + "/*"}
            element={<ReportingContainer />}
          />
          <Route
            path={paths.prospects.base.pattern + "/*"}
            element={<ProspectContainer />}
          />
          <Route path="*" element={<ClientContainer />} />
        </Routes>
      </Container>
    </>
  );
}

export default Content;
